import * as lexActionType from '../actionsType/lexLoginDSP.actionType';

export const initialState = {
    response: null,
    exception: null
};

export function lexLoginDSPReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.LEX_LOGINDSP_SUCCESS:
            return {...state, response: action.payload};
        case lexActionType.LEX_LOGINDSP_ERROR:
            return {...state, exception: lexActionType.LEX_LOGINDSP_ERROR};
        default:
            return state;
    }
}
